<div class="general-page">
    <div class="content-box">
        <div class="row">
            <div class="col-sm-12 general-page__content">
                <div class="general-card">
                    <div class="general-card__header">
                        <img src="/assets/images/Group 9.svg" alt="" />
                        <div class="general-card__header-headline">
                            <h2>Bine ați venit!</h2>
                            <h4>Programări</h4>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12">
                <div class="section">
                    <div class="section-top">
                        <h3 class="section-title">Programări</h3>
                        <div class="section-top-actions">
                            <button type="button" class="btn btn-sm btn-info pull-right ms-1"
                                (click)="rerenderDT(false)">
                                <i class="fa-solid fa-arrows-rotate"></i>
                            </button>
                            <button *ngIf="permissionsService.hasPermission('deps-module.programari.print')"
                                type="button" class="btn btn-sm btn-primary pull-right ms-1"
                                (click)="printProgramari()">
                                <i class="fa-solid fa-print"></i>
                                Print
                            </button>
                        </div>
                    </div>

                    <div class="p-3 d-flex flex-row flex-wrap">
                        <div class="input-filter me-3">
                            <mat-form-field class="w-100">
                                <mat-label>Modul</mat-label>
                                <mat-select [(ngModel)]="moduleId" (selectionChange)="onModuleChange($event.value)">
                                    <mat-option *ngFor="let row of modules$ | async" [value]="row.id">
                                        {{ row.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="input-filter me-3">
                            <mat-form-field class="w-100">
                                <mat-label>Locație</mat-label>
                                <mat-select [(ngModel)]="locatieId" (selectionChange)="rerenderDT(true)">
                                    <mat-option *ngFor="let row of locatii$ | async" [value]="row.id">
                                        {{ row.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="input-filter me-3">
                            <mat-form-field class="w-100">
                                <mat-label>Tip programare</mat-label>
                                <mat-select [(ngModel)]="tipProgramare" (selectionChange)="rerenderDT(true)">
                                    <mat-option *ngFor="let param of tipuriProgramari" [value]="param.id">
                                        {{ param.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="input-filter me-3">
                            <mat-form-field class="w-100">
                                <mat-label>Dată programare</mat-label>
                                <input matInput [matDatepicker]="picker" (dateChange)="onDateChange($event)"
                                    [(ngModel)]="dataProgramare" />
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="table-container">
                        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover w-100">
                        </table>
                    </div>
                    <div class="section-spinner position-absolute" *ngIf="isLoading">
                        <div class="spinner position-absolute top-50 start-50 translate-middle">
                            <mat-spinner></mat-spinner>
                            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>